/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
//import classnames from 'classnames';
import * as React from 'react';

import { IObrienIdContainerConfig, IObrienIdContainerProps } from './obrien-id-container.props.autogenerated';


export interface IObrienIdContainerViewProps extends IObrienIdContainerProps<IObrienIdContainerConfig> {

    simpleRowcategories?: React.ReactNode[];
    simpleRowList: IModuleProps;
    simpleRowListItem: INodeProps;
    
    obrienId: string;
    obrienClass: string;
    
   
}


/**
 *
 * ObrienIdContainer component.
 * @extends {React.PureComponent<IObrienIdContainerProps<IObrienIdContainerConfig>>}
 */
 class ObrienIdContainer extends React.PureComponent<IObrienIdContainerProps<IObrienIdContainerConfig>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const ObrienId = config.obrienId ? config.obrienId : '';
        const ObrienClass = config.obrienClass ? config.obrienClass : '';

        if (!this.props.slots || !this.props.slots.simpleRow || this.props.slots.simpleRow.length === 0) {
            this.props.context.telemetry.error('row1 is empty, module wont render');
            return null;
        }
        


        const viewprops = {
            ...this.props,

            obrienId: ObrienId,
            obrienClass: ObrienClass,
            
            simpleRowcategories: this.props.slots.simpleRow,
            simpleRowList: {
                moduleProps: this.props,
                tag: 'div'
            },
            simpleRowListItem: {
                tag: 'div'
            },
            
            
        };

        return this.props.renderView(viewprops) as React.ReactElement;
        
    }
}

export default ObrienIdContainer;
